import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function money(n) {
  if (n == null || isNaN(n)) return "—";
  return `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function moneyUnit(n) {
  if (n == null || isNaN(n)) return "—";
  return `$${Number(n).toFixed(4)}`;
}

/**
 * Resolves a product image URL. Backend-relative paths (e.g. "/api/static/products/x.png")
 * get the backend host prepended; absolute https:// URLs (Unsplash etc.) pass through unchanged.
 */
// Resized WebP variant for grid thumbnails (only for objects we serve ourselves).
export function productThumb(url, w = 600) {
  const full = productImage(url);
  return full.includes("/api/files/") ? `${full}${full.includes("?") ? "&" : "?"}w=${w}&fmt=webp` : full;
}

export function productImage(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) {
    return url;
  }
  return `${BACKEND_URL}${url.startsWith("/") ? "" : "/"}${url}`;
}
